<template>
    <div class="alert bg-light p-5"
    v-html="$sanitize(row.display_content)">
    </div>
</template>


<script>

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        },

    }
</script>